import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  suffix?: React.ReactNode;
}
export function CtaButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  suffix
}: CtaButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    boxShadow: '0 0 0 rgba(201, 168, 76, 0)'
  }} animate={{
    boxShadow: ['0 0 0 rgba(201, 168, 76, 0)', '0 0 15px rgba(201, 168, 76, 0.3)', '0 0 0 rgba(201, 168, 76, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    },
    scale: {
      duration: 0.1
    }
  }} onClick={onClick} className={`
        bg-brand-gold hover:bg-brand-gold-dark text-brand-bg font-bold py-4 px-8 rounded-lg 
        text-lg md:text-xl transition-colors duration-200 flex items-center justify-center gap-2
        shadow-lg shadow-brand-gold/10
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-755">
      {children}
      <ArrowRight className="w-5 h-5 md:w-6 md:h-6 shrink-0" data-id="element-756" />
      {suffix && <span className="shrink-0" data-id="element-757">{suffix}</span>}
    </motion.button>;
}